import { t } from "@redotech/redo-i18n";
import { Assign } from "@redotech/redo-return-core-common/return-flow/action";
import { ActionType } from "@redotech/redo-return-core-common/return-flow/action-enums";
import * as React from "react";
import { ActionTypeSetup, RuleTypeDetailsProps } from "./multiple-actions";

export interface AssignState {
  user: { id: string; name: string };
}

export const ASSIGN = (
  Details: React.ComponentType<RuleTypeDetailsProps<AssignState>>,
): ActionTypeSetup<AssignState, Assign> => ({
  get name() {
    return t("Assign to agent");
  },
  description() {
    return t("Assign the ticket to an agent");
  },
  Details(props: RuleTypeDetailsProps<AssignState>) {
    return React.createElement(Details, props);
  },
  empty: { user: { id: "", name: "" } },
  fromModel(model) {
    return { user: model.user };
  },
  toModel(state) {
    return { type: ActionType.Assign, user: state.user };
  },
  valid(state) {
    return !!state.user?.id;
  },
});
